export default __webpack_public_path__ + "static/media/bgg.ffa319c4.jpg";